import React from 'react';
import { ShoppingCart, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

export function CartPopup() {
  const { items, removeItem } = useCart();
  
  if (items.length === 0) return null;

  const total = items.reduce((sum, item) => sum + ((item.price || 0) * (item.quantity || 1)), 0);

  return (
    <div className="absolute top-full right-0 mt-2 w-80 bg-white rounded-lg shadow-lg p-4 z-50">
      <div className="max-h-64 overflow-y-auto mb-4">
        {items.map((item) => (
          <div key={item.id} className="flex items-center gap-3 py-2 border-b last:border-0">
            <img
              src={item.image}
              alt={item.name}
              title={item.name}
              className="w-12 h-12 object-cover rounded"
            />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">{item.name}</p>
              <div className="flex items-center justify-between mt-1">
                <p className="text-sm text-[#4FC1E9]">{(item.price || 0).toFixed(2)}€</p>
                <p className="text-xs text-gray-500">Kogus: {item.quantity || 1}</p>
              </div>
            </div>
            <button 
              onClick={() => removeItem(item.id)}
              className="text-gray-400 hover:text-red-500 transition-colors"
              aria-label="Eemalda toode"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
      <div className="border-t pt-3">
        <div className="flex justify-between mb-3">
          <span className="font-medium">Kokku:</span>
          <span className="font-bold text-[#4FC1E9]">{total.toFixed(2)}€</span>
        </div>
        <Link 
          to="/ostukorv"
          className="w-full bg-[#4FC1E9] text-white py-2 px-4 rounded-full flex items-center justify-center hover:bg-[#3ba8d0] transition-colors"
        >
          <ShoppingCart className="w-4 h-4 mr-2" />
          Mine ostukorvi
        </Link>
      </div>
    </div>
  );
}
